export default "__VITE_ASSET__6Ukc6T4K__"